<template>
  <div class="star-rating__container">
    <div class="star-rating__star-wrapper">
      <svg class="star-rating__star" version="1.1" id="Layer_1_1543844427829" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         x="0px" y="0px" viewBox="0 0 30 28" xml:space="preserve">
      <path vector-effect="non-scaling-stroke" class="st0" d="M28.1,10.2l-8.5-1.2l-3.8-7.4c-0.2-0.5-0.5-0.7-0.7-0.7s-0.7,0.2-0.8,0.6
        l-3.8,7.5l-8.4,1.2c-0.7,0.1-0.9,0.4-0.9,0.7c0,0.3,0.2,0.5,0.5,0.8l6.1,5.8L6,25.7c0,0.2,0,0.3,0,0.4c0,0.3,0.1,0.5,0.2,0.5
        c0.1,0.2,0.3,0.3,0.6,0.3c0.2,0,0.5-0.1,0.7-0.2l7.6-3.9l7.6,3.9c0.3,0.1,0.5,0.2,0.7,0.2c0.5,0,0.7-0.3,0.7-0.8c0-0.2,0-0.3,0-0.4
        l-1.5-8.2l6.1-5.8c0.3-0.3,0.5-0.5,0.5-0.8C29.1,10.6,28.7,10.3,28.1,10.2"/>
      <path vector-effect="non-scaling-stroke" class="st1" d="M28.1,10.2l-8.5-1.2l-3.8-7.4c-0.2-0.5-0.5-0.7-0.7-0.7s-0.7,0.2-0.8,0.6
        l-3.8,7.5l-8.4,1.2c-0.7,0.1-0.9,0.4-0.9,0.7c0,0.3,0.2,0.5,0.5,0.8l6.1,5.8L6,25.7c0,0.2,0,0.3,0,0.4c0,0.3,0.1,0.5,0.2,0.5
        c0.1,0.2,0.3,0.3,0.6,0.3c0.2,0,0.5-0.1,0.7-0.2l7.6-3.9l7.6,3.9c0.3,0.1,0.5,0.2,0.7,0.2c0.5,0,0.7-0.3,0.7-0.8c0-0.2,0-0.3,0-0.4
        l-1.5-8.2l6.1-5.8c0.3-0.3,0.5-0.5,0.5-0.8C29.1,10.6,28.7,10.3,28.1,10.2 M21.4,23.7L15,20.4l-6.4,3.3l1.2-6.9L4.7,12l7.1-1L15,4.7
        l3.2,6.3l7.1,1l-5.2,4.9L21.4,23.7z"/>
      </svg>
      <span class="star-rating__star__number"></span>
    </div>
    <p class="star-rating__text">{{ text }}</p>
  </div>
</template>

<script>

  export default {
    name: 'Star',
    props: {
      text: String,
      starId: Number,
    }
  }
</script>
